/**
 * plugins/vuetify.ts
 *
 * Framework documentation: https://vuetifyjs.com`
 */

// Styles
import { Icon } from '@iconify/vue';
import '@mdi/font/css/materialdesignicons.css';
import { aliases, mdi } from 'vuetify/iconsets/mdi';
import 'vuetify/styles'; // I unsure why I have to import this here since we import main.scss in nuxt.config.ts, but it seems to be necessary

// Composables
import DayJsAdapter from '@date-io/dayjs';
import { createVuetify, type ThemeDefinition } from 'vuetify';

const amvCustomLightTheme: ThemeDefinition = {
  dark: false,
  colors: {
    background: '#F4F5FA',
    primary: '#041e43',
    'amv-yellow': '#f0b323',
    'amv-blue': '#041e43',
  },
};

export default defineNuxtPlugin(nuxtApp => {
  const vuetify = createVuetify({
    ssr: false, // I have experienced problems with this = true when npm run dev
    // We don't want to include all components and directives regardless of whether or not we are using them.
    // so we use treeshaking which is configured in nuxt.config.ts
    // components,
    // directives,
    components: {},
    theme: {
      defaultTheme: 'amvCustomLightTheme',
      themes: {
        amvCustomLightTheme,
      },
    },
    locale: {
      locale: 'en',
    },
    date: {
      adapter: DayJsAdapter,
    },
    icons: {
      defaultSet: 'mdi',
      aliases,
      sets: {
        mdi,
      },
    },
    defaults: {
      global: {
        // settings put in global will have effect on all components
        // density: 'comfortable'
      },
      VTextField: {
        variant: 'outlined',
      },
      VSelect: {
        variant: 'outlined',
      },
      VAutocomplete: {
        variant: 'outlined',
      },
      VBtnToggle: {
        variant: 'outlined',
      },
      VCardText: {
        style: 'font-size: 1rem',
      },
      VDataTableServer: {
        itemsPerPageOptions: [
          { title: '5', value: 5 },
          { title: '10', value: 10 },
          { title: '15', value: 15 },
          { title: '25', value: 25 },
          { title: '50', value: 50 },
          { title: '100', value: 100 },
        ],
      },
      VDataTable: {
        itemsPerPageOptions: [
          { title: '5', value: 5 },
          { title: '10', value: 10 },
          { title: '15', value: 15 },
          { title: '25', value: 25 },
          { title: '50', value: 50 },
          { title: 'All', value: -1 },
        ],
      },
    },
  });

  nuxtApp.vueApp.use(vuetify);
  nuxtApp.vueApp.component('Icon', Icon);
});
